import React, { PureComponent } from "react";
import PropTypes from "prop-types";
import SortableElement from "./views/sortable";
import { themeOptions } from "styles/theme";
import S3Uploader from "components/form/direct-s3-uploader";
import siteConfig from "site-config";
import { merge, $ } from "glamor";
import Globalize from "globalize";
import IconMenu from "material-ui/IconMenu";
import MenuItem from "material-ui/MenuItem";
import IconButton from "material-ui/IconButton";
import MoreVertIcon from "material-ui/svg-icons/navigation/more-vert";
import classNames from "classnames";
import DragHandle from "components/items/drag-handle";
import Confirm from "components/dialog/confirm";

const uploaderStyle = {
    width: "100%",
    height: "300px",
    paddingTop: "60px",
    uploadIconStyle: {
        width: "156px",
        height: "135px",
    },
    instructionsStyle: {
        fontSize: "20px",
        marginTop: "25px",
    },
    uploadInstructionsStyle: {
        width: "320px",
    },
    spinnerStyle: {
        top: "160px",
        left: "50%",
    },
    slide: {
        height: "300px",
        overflow: "hidden",
    },
    carouselImageContainer: {
        height: "300px",
        position: "relative",
        backgroundSize: "cover",
        backgroundRepeat: "no-repeat",
        backgroundPosition: "center",
        filter: "blur(5px)",
        opacity: 0.4,
    },
    carouselImage: {
        height: "300px",
        position: "relative",
        backgroundSize: "contain",
        backgroundRepeat: "no-repeat",
        backgroundPosition: "center",
        top: "-300px",
    },
};
const MUIStyle = {
    iconButton: {
        borderRadius: "50%",
        backgroundColor: "#fff",
        width: "32px",
        height: "32px",
    },
    iconMenu: {
        position: "absolute",
        top: 0,
        right: 8,
        zIndex: 1,
    },
    listIconMenu: {
        position: "absolute",
        right: 16,
        zIndex: 1,
    },
    iconMenuNone: {
        display: "none",
    },
    dragHandle: {
        opacity: 1,
        width: "48px",
        height: "48px",
        padding: "12px",
        top: "0px",
    },
    actionsContainer: {
        display: "flex",
        justifyContent: "space-around",
    },
};
const origin = { horizontal: "right", vertical: "top" };

/** @augments {PureComponent<any, any>} */
class ImageSeparator extends PureComponent {
    static propTypes = {
        catalogEntry: PropTypes.object.isRequired,
        style: PropTypes.object.isRequired,
        scope: PropTypes.object.isRequired,
        list: PropTypes.bool,
    };

    styles = merge(
        {
            cursor: "pointer",
        },
        $(" .uploaderWrapper", {
            backgroundColor: themeOptions.palette.lighterGrey,
            minHeight: "300px",
            position: "relative",
        }),
        $(" .dropTargetHidden", {
            display: "none",
        }),
    );

    state = {
        callbackErrorMessage: "",
        isIconMenuOpen: false,
        isModalOpen: false,
        hover: false,
        deleteImageOrEntry: null,
        imageStyle: null,
        imageContainerStyle: null,
    };

    UNSAFE_componentWillMount() {
        const { options } = this.props.catalogEntry;
        this.renderImage(options);
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        const { options } = nextProps.catalogEntry;
        this.renderImage(options);
    }

    renderImage = ({ name, ext }) => {
        if (name && ext) {
            const backgroundImage = {
                backgroundImage: `url(//cdn1.nuorder.com/image_separator/${name}${ext})`,
            };
            const imageStyle = Object.assign(
                {},
                uploaderStyle.carouselImage,
                backgroundImage,
                this.props.style.carouselImage,
            );
            const imageContainerStyle = Object.assign({}, uploaderStyle.carouselImageContainer, backgroundImage);

            this.setState({
                imageStyle,
                imageContainerStyle,
            });
        }
    };

    handleDeleteEntry = () => {
        const { catalogEntry, actions } = this.props;

        this.setState(
            {
                isIconMenuOpen: false,
                isModalOpen: false,
            },
            () => {
                actions.onDelete(catalogEntry);
            },
        );
    };

    handleUpdateEntry = (updates) => {
        const { catalogEntry, actions } = this.props;
        const changes = { options: {} };

        if (updates && updates.originals && updates.originals.length) {
            const { ext, name, original_name } = updates.originals[0];
            changes.options = {
                ext,
                name,
                original_name,
            };
        }

        actions.onUpdate(catalogEntry, changes);
    };

    handleUploadError = (error) => {
        const { onSnackbarAdd } = this.props;

        this.setState(
            {
                callbackErrorMessage: error.message,
            },
            () => {
                onSnackbarAdd(error);
            },
        );
    };

    handleOpenModal = () => {
        this.setState({ isModalOpen: true });
    };

    handleCloseModal = () => {
        this.setState({
            isModalOpen: false,
            deleteImageOrEntry: null,
        });
    };

    handleMouseLeave = () => {
        const { isIconMenuOpen } = this.state;
        if (!isIconMenuOpen) {
            this.setState({
                hover: false,
            });
        }
    };

    handleMouseEnter = () => {
        this.setState({
            hover: true,
        });
    };

    handleIconMenuRequestChange = (open, reason) => {
        if (!open) {
            this.setState({
                isIconMenuOpen: false,
            });
        } else {
            this.setState({
                isIconMenuOpen: true,
            });
        }
    };

    handleEventBubbling = (event) => {
        event.preventDefault();
    };

    supportsTouch = "ontouchstart" in window || navigator.msMaxTouchPoints;

    render() {
        const { style, editable, isDragging, iconIsSeparator, connectDragSource, scope, list } = this.props;
        const { callbackErrorMessage, imageStyle, imageContainerStyle, isModalOpen, hover, isIconMenuOpen } =
            this.state;
        const iconMenuStyle = list ? MUIStyle.listIconMenu : MUIStyle.iconMenu;

        return (
            <div
                {...this.styles}
                style={style}
                onMouseLeave={this.handleMouseLeave}
                onMouseEnter={this.handleMouseEnter}
            >
                {editable && (hover || this.supportsTouch) && (
                    <div>
                        <IconMenu
                            open={isIconMenuOpen}
                            onRequestChange={this.handleIconMenuRequestChange}
                            onClick={this.handleEventBubbling}
                            iconButtonElement={
                                <IconButton iconStyle={MUIStyle.iconButton}>
                                    <MoreVertIcon />
                                </IconButton>
                            }
                            anchorOrigin={origin}
                            targetOrigin={origin}
                            style={isDragging || !iconIsSeparator ? MUIStyle.iconMenuNone : iconMenuStyle}
                        >
                            <MenuItem
                                onClick={this.handleOpenModal}
                                primaryText={Globalize.formatMessage("Delete Image")}
                            />
                        </IconMenu>
                        <Confirm
                            title={Globalize.formatMessage("Are you sure you want to delete this image separator?")}
                            open={isModalOpen}
                            onCancel={this.handleCloseModal}
                            onConfirm={this.handleDeleteEntry}
                            actionsContainerStyle={MUIStyle.actionsContainer}
                        />
                    </div>
                )}

                {imageStyle && imageContainerStyle && (
                    <div
                        style={uploaderStyle.slide}
                        className={classNames({
                            dropTargetHidden: isDragging && !this.supportsTouch,
                        })}
                    >
                        {editable && this.supportsTouch && (
                            <DragHandle
                                connectDragSource={connectDragSource}
                                style={MUIStyle.dragHandle}
                                iconStyle={MUIStyle.iconButton}
                            />
                        )}
                        <div style={imageContainerStyle} />
                        <div style={imageStyle} />
                    </div>
                )}

                {!imageStyle && !imageContainerStyle && (
                    <div
                        className={classNames({
                            uploaderWrapper: true,
                            dropTargetHidden: (isDragging || !iconIsSeparator) && !this.supportsTouch,
                        })}
                    >
                        {editable && this.supportsTouch && (
                            <DragHandle
                                connectDragSource={connectDragSource}
                                style={MUIStyle.dragHandle}
                                iconStyle={MUIStyle.iconButton}
                            />
                        )}
                        <S3Uploader
                            editable={editable}
                            accept="image/jpeg, image/jpg, image/png"
                            isLegacy={true}
                            onUploadError={this.handleUploadError}
                            specifications={[
                                Globalize.formatMessage("RGB @ 72dpi"),
                                Globalize.formatMessage("Recommended Size: |size|", { size: "1200px x 300px" }),
                                Globalize.formatMessage("Maximum Size: |size|", { size: "3200px x 3200px" }),
                            ]}
                            spinnerStyle={uploaderStyle.spinnerStyle}
                            style={uploaderStyle}
                            uploadCallback={this.handleUpdateEntry}
                            uploadCallbackErrorMessage={callbackErrorMessage}
                            uploadIconStyle={uploaderStyle.uploadIconStyle}
                            uploadInstructions={Globalize.formatMessage("Drag or click image to upload")}
                            uploadUrl={`${siteConfig.api}/assets/upload/image/image_separator`}
                            scope={scope}
                        />
                    </div>
                )}
            </div>
        );
    }
}

export const SortableImage = SortableElement(ImageSeparator);

export default ImageSeparator;
